<template lang="">
    <div v-if="open" class="fixed top-28 md:top-2 right-2 z-40">
        <div v-if="alertMessage.alert==1" class="w-80 h-auto flex p-2 m-2 flex-col bg-green-600 rounded-xl shadow-2xl">
            <XIcon class="absolute w-6 h-6 mb-4 cursor-pointer right-5 hover:text-white" @click="closeAlert"/>
            <p class="text-sm font-bold my-6 text-white">{{alertMessage.message}}</p>
        </div>
        <div v-if="alertMessage.alert==2" class="w-80 h-auto flex p-2 m-2 flex-col bg-red-600 rounded-xl shadow-2xl">
            <XIcon class="absolute w-6 h-6 mb-4 cursor-pointer right-5 hover:text-white" @click="closeAlert"/>
            <p class="text-sm font-bold my-6 text-white">{{alertMessage.message}}</p>
        </div>
        <div v-if="alertMessage.alert==3" class="w-80 h-auto flex p-2 m-2 flex-col bg-amber-600 rounded-xl shadow-2xl">
            <XIcon class="absolute w-6 h-6 mb-4 cursor-pointer right-5 hover:text-white" @click="closeAlert"/>
            <p class="text-sm font-bold my-6 text-white">{{alertMessage.message}}</p>
        </div>
    </div>
</template>

<script>

    import { XIcon } from '@heroicons/vue/outline'

    export default {
        components: {
            XIcon
        },
        data(){
            return {
                closeMessage : false,
                open : false
            }
        },
        props : {
            alertMessage : {
                type : Object,
                default : {alert : 0, message : ''}
            },   //[1 success, 2 error , 3 warning]
        },
        watch :{
            'alertMessage.alert'(val){
                this.closeMessage = null
                if(val > 0){
                    this.open = true
                    this.closeMessage = setTimeout( ()=> {
                        this.closeAlert()
                    },7000)
                }
            }
        },
        methods: {
            closeAlert(){
                this.closeMessage = null
                this.alertMessage.alert = 0
                this.open = false
            }
        }
    }
</script>
